// Public surface of @percent/domain/ai-chat. The Vercel AI SDK (`ai` /
// `@ai-sdk/react`) is wrapped inside the lib; consumers depend only on this entry
// point and never import the SDK directly.

import { QuestionInput } from './components/QuestionInput/QuestionInput'
import { SuggestionChip } from './components/SuggestionChip/SuggestionChip'
import { QuestionBox } from './components/QuestionBox/QuestionBox'
import { Answer } from './components/Answer/Answer'
import { Conversation } from './components/Conversation/Conversation'

/**
 * The ai-chat component namespace. Compose an agent's chat UI from these generic,
 * Lemonade-styled pieces and drive them with {@link useAiChat}:
 *
 * ```tsx
 * const chat = useAiChat({ basePath: `${baseUrl}insights/chat`, fetch: authedFetch })
 * <AiChat.Conversation chat={chat} renderData={renderMetrics} … />
 * ```
 */
export const AiChat = {
  QuestionInput,
  SuggestionChip,
  QuestionBox,
  Answer,
  Conversation,
}

export { useAiChat } from './hooks/useAiChat'
export { stripResidualTokens } from './utils/stripResidualTokens'
export { parseEventStream } from './transport/parseEventStream'

export type {
  BackendChatEvent,
  BackendChatTransportConfig,
  AiChatDataPart,
  AiChatDebugEvent,
  AiChatDebugTurn,
  AiChatMessage,
  AiChatStatus,
  UseAiChatConfig,
  UseAiChatResult,
} from './types/aiChat.types'
export type { QuestionInputProps } from './components/QuestionInput/QuestionInput'
export type { SuggestionChipProps } from './components/SuggestionChip/SuggestionChip'
export type { QuestionBoxProps } from './components/QuestionBox/QuestionBox'
export type { AnswerProps } from './components/Answer/Answer'
export type { ConversationProps } from './components/Conversation/Conversation'
